export interface Token {
  cid: string;
  token: string;
  ticket?: string;
}

export interface User {
  uid: number;
  uidName: string;
  cid: number;
  cidName: string;
  mobilePhone: string;
  email: string;
  resultDetaul: string;
  superAdmin: number;
  appAdmin: number;
  existCoop: number;
}

// action类型枚举
export const enum AuthorizationActionTypes {

  // 获取用户信息
  FETCH_USER_INFO = "@@authorization/FETCH_USER_INFO",
  FETCH_USER_INFO_FINISH = "@@authorization/FETCH_USER_INFO_FINISH",
  FETCH_USER_INFO_ERROR = "@@authorization/FETCH_USER_INFO_ERROR",

  // 获取系统基础信息
  FETCH_SYS_PARAM = "@@sys_param/FETCH_SYS_PARAM",
  FETCH_SYS_PARAM_FINISH = "@@sys_param/FETCH_SYS_PARAM_FINISH",
};

// Authorization state
export interface AuthorizationState {
  isLogin: boolean;
  userInfo: User;
  sysParam: any;
}



// WEBPACK FOOTER //
// ./src/store/authorization/types.ts